import {css} from '@yandex-delivery/blocks/theme/css'

export const segment = css`
  flex: 0 0 auto;
  overflow: visible;

  && > * {
    overflow: visible;
  }
`

export const box = css`
  overflow: visible;
`
